import axios from 'axios';
import { req, serverURL } from './axiosFun';
export const login = (params) => { return req("post", "/admin/managers/login", params) };

export const imagesrc = serverURL + "/admin/file/upload"

export const getUploadHeader = () => { return { "token": localStorage.getItem('token') } }
export const getExcelSrc = (params) => {
    var query = []
    for (var i in params) {
        query.push(i.replace(/[A-Z]/g, (p) => {
            return '_' + p.toLowerCase()
        }) + '=' + params[i])
    }
    return serverURL + "/admin/import/words?" + query.join('&')

}

export const getAudioSrc = (params) => {
    var query = []
    for (var i in params) {
        query.push(i.replace(/[A-Z]/g, (p) => {
            return '_' + p.toLowerCase()
        }) + '=' + params[i])
    }
    return serverURL + "/admin/import/audio?" + query.join('&')

}


export const getYongAudioSrc = (params) => {
    var query = []
    for (var i in params) {
        query.push(i.replace(/[A-Z]/g, (p) => {
            return '_' + p.toLowerCase()
        }) + '=' + params[i])
    }
    return serverURL + "/admin/import/yongaudio?" + query.join('&')

}

export const bookslist = (params) => { return req("post", "/admin/word-books/list", params) };
export const booksdelete = (params) => { return req("post", "/admin/word-books/delete", params) };
export const bookscreate = (params) => { return req("post", "/admin/word-books/create", params) };
export const booksupdate = (params) => { return req("post", "/admin/word-books/update", params) };
export const bookstypes = (params) => { return req("post", "/admin/word-books/types", params) };
export const booksupdateCount = (params) => { return req("post", "/admin/word-books/update_count", params) };
export const bookunitlist = (params) => { return req("post", "/admin/word-books/units", params) };
export const bookunitupdate = (params) => { return req("post", "/admin/word-books/units/update", params) };
export const bookunitdelete = (params) => { return req("post", "/admin/word-books/units/delete", params) };
export const booksqrcode = (params) => { return req("post", "/admin/word-books/qrcode", params) };
export const wordslistpos = (params) => { return req("post", "/admin/words/list_pos", params) };
export const wordslist = (params) => { return req("post", "/admin/words/list", params) };
export const wordssave = (params) => { return req("post", "/admin/words/save", params) };
export const wordsupdate = (params) => { return req("post", "/admin/words/update", params) };
export const wordVideoUploadAuth = (params) => { return req("post", "/admin/file/video/upload-auth", params) };
export const wordsdelete = (params) => { return req("post", "/admin/words/delete", params) };
export const wordsyongword = (params) => { return req("post", "/admin/words/yong/word", params) };
export const categorylist = (params) => { return req("post", "/admin/category/list", params) };
export const categoryadd = (params) => { return req("post", "/admin/category/add", params) };
export const categoryupdate = (params) => { return req("post", "/admin/category/update", params) };
export const categorydelete = (params) => { return req("post", "/admin/category/delete", params) };
export const managerslist = (params) => { return req("post", "/admin/managers/list", params) };
export const managersdetail = (params) => { return req("post", "/admin/managers/detail", params) };
export const managerscreate = (params) => { return req("post", "/admin/managers/create", params) };
export const managersupdate = (params) => { return req("post", "/admin/managers/update", params) };
export const managersstatus = (params) => { return req("post", "/admin/managers/update/status", params) };
export const managersdelete = (params) => { return req("post", "/admin/managers/delete", params) };
export const managersbatchdelete = (params) => { return req("post", "/admin/managers/batch/delete", params) };
export const managerscgpwd = (params) => { return req("post", "/admin/managers/change_password", params) };
export const managerscgmypwd = (params) => { return req("post", "/admin/managers/change_my_password", params) };
export const configget = (params) => { return req("post", "/admin/system/config/get", params) };
export const configupdate = (params) => { return req("post", "/admin/system/config/update", params) };
export const userslist = (params) => { return req("post", "/admin/users/list", params) };
export const userranklist = (params) => { return req("post", "/admin/user-rank/list", params) };
export const userrankdetail = (params) => { return req("post", "/admin/user-rank/detail", params) };
export const userrankupdate = (params) => { return req("post", "/admin/user-rank/update", params) };
export const userranksettle = (params) => { return req("post", "/admin/user-rank/settle", params) };
export const checkinstats = (params) => { return req("post", "/admin/check-in/stats", params) };
export const feedbacklist = (params) => { return req("post", "/admin/feedback/list", params) };
export const feedbackupdate = (params) => { return req("post", "/admin/feedback/update/status", params) };
export const messageslist = (params) => { return req("post", "/admin/messages/list", params) };
export const messages = (params) => { return req("post", "/admin/messages", params) };
export const codelist = (params) => { return req("post", "/admin/book-redeem-code/list", params) };
export const generate = (params) => { return req("post", "/admin/book-redeem-code/generate", params) };
export const codedownload = (params) => { return req("post", "/admin/book-redeem-code/download", params) };
export const codeexport = (params) => { return req("post", "/admin/book-redeem-code/export", params) };

export const shippinglist = (params) => { return req("post", "/admin/shipping/list", params) };
export const shippingupdate = (params) => { return req("post", "/admin/shipping/update", params) };


export const bannerslist = (params) => { return req("post", "/admin/banners/list", params) };
export const bannersdelete = (params) => { return req("post", "/admin/banners/delete", params) };
export const bannerscreate = (params) => { return req("post", "/admin/banners/add", params) };
export const bannersdetail = (params) => { return req("post", "/admin/banners/detail", params) };
export const bannersupdate = (params) => { return req("post", "/admin/banners/update", params) };
export const bannersupdatesort = (params) => { return req("post", "/admin/banners/updateSort", params) };
export const bannersupdatestatus = (params) => { return req("post", "/admin/banners/updateStatus", params) };










// WEBPACK FOOTER //
// ./src/api/userMG.js